// File: cgp-check-all.module.ts
// Author: Joseph M Diaz
// Date: 6/12/2018
// Desc: CGP Check All Module.
// Other Contributors:

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { CgpCheckAllComponent } from './cgp-check-all.component';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';

@NgModule({
    imports: [
        BrowserModule,
        MatButtonModule,
        MatMenuModule
    ],
    exports: [
        CgpCheckAllComponent
    ],
    declarations: [
        CgpCheckAllComponent
    ]
})
export class CgpCheckAllModule { }
